import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "add-assignee",
  "use": "add-assignee-usage",
  "viewBox": "-6 -7 37 37",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" viewBox=\"-6 -7 37 37\" id=\"add-assignee\"><path d=\"M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2\" /><circle cx=\"12\" cy=\"7\" r=\"4\" /><circle cx=\"12\" cy=\"12\" r=\"17\" /><circle cx=\"24\" r=\"6\" fill=\"#fff\" /><path d=\"M24-3v6m3-3h-6\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol